import React from 'react'
import { useLocalStorageState } from 'ahooks'
import { useAppSelector } from '../hooks'
import { DepartmentMemberV2 } from '../../global'
import { SelectedDepartment } from '../../pages/components/DepartmentMemberPickerV2'

const maxHistoryLength = 10

type HistoryItem = SelectedDepartment | DepartmentMemberV2

export const useFilterMemberHistory = () => {
  const groupID = useAppSelector((state) => state.group.groupId)
  const [history, setHistory] = useLocalStorageState<HistoryItem[]>(
    `${groupID}_search_user_history`,
    {
      defaultValue: [],
      listenStorageChange: true
    }
  )

  const addHistory = (
    selectedDepartments: SelectedDepartment[] = [],
    selectedDepartmentUsers: DepartmentMemberV2[] = []
  ) => {
    if (
      selectedDepartments.length === 0 &&
      selectedDepartmentUsers.length === 0
    )
      return
    if (selectedDepartments.some((dept) => dept.id === '0')) return

    // 确保生成的类型是正确的 HistoryType
    const newItems: HistoryItem[] = [
      ...selectedDepartments,
      ...selectedDepartmentUsers
    ]

    setHistory((prevHistory = []) => {
      const uniqueItems = new Map<string, HistoryItem>()

      // 合并新数据和历史数据，按照插入顺序去重
      newItems.concat(prevHistory).forEach((item) => {
        const key =
          'userID' in item ? `user_${item.userID}` : `department_${item.id}`
        if (!uniqueItems.has(key)) {
          uniqueItems.set(key, item)
        }
      })

      // 转换为数组并限制最大长度
      return Array.from(uniqueItems.values()).slice(0, maxHistoryLength)
    })
  }

  const clearHistory = () => {
    setHistory([])
  }

  return {
    history,
    addHistory,
    clearHistory
  }
}
